module.exports = __webpack_public_path__ + "img/raw_bag_zhb.805643e8.svg";